import Login from '@/components/login/login'
import Forget from '@/components/login/forget'
import Register from '@/components/login/register'
export default [
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录'
    },
    component: Login
  }, {
    path: '/forget',
    name: 'Forget',
    meta: {
      title: '找回密码'
    },
    component: Forget
  }, {
    path: '/register',
    name: 'Register',
    meta: {
      title: '快速注册'
    },
    component: Register
  }
]



// WEBPACK FOOTER //
// ./src/router/login.js